// import { observer } from 'mobx-react-lite';
// import React, { useEffect, useState } from 'react';
// import { FormattedMessage, useIntl } from 'react-intl';

// import { getLanguageAsApiParam } from '../../util/localeUtil';

// import { useApi } from '../../components/ApiProvider';
// import ContentPageWrapper from '../../components/ContentPageWrapper';
// import Title from '../../components/Title';
// import Layout from '../../components/Layout';
// import Link from '../../components/Link';
// import SEO from '../../components/SEO';

// import styles from './instructions.module.scss';
// import PlayIcon from '../../images/play.svg';

// const InstructionsPage = ({ uri }) => {
//   const intl = useIntl();
//   const apiClient = useApi();

//   const [items, setItems] = useState([]);

//   useEffect(() => {
//     const fetchItems = async () => {
//       const language = getLanguageAsApiParam(intl.locale);

//       const result = await apiClient.sendRequest(
//         'get',
//         '/api/v1/instructions',
//         {
//           query: {
//             product_code: 'r2d2',
//             language
//           }
//         }
//       );

//       setItems(result.data.response);
//     };
//     fetchItems();
//   }, [apiClient, intl.locale]);

//   return (
//     <Layout alwaysRaisedHeader uri={uri}>
//       <SEO
//         title={intl.formatMessage({
//           id: 'meta.title.instructions',
//           defaultMessage: 'Online Assembly Instruction'
//         })}
//         description={intl.formatMessage({
//           id: 'meta.description.instructions',
//           defaultMessage:
//             'Easy to follow assembly instructions and videos for Build Your Own R2-D2. Order now and start building!'
//         })}
//       />
//       <ContentPageWrapper>
//         <Title centered>
//           <FormattedMessage defaultMessage="Online Assembly Instruction" />
//         </Title>
//         <div className={styles.steps}>
//           {items.map(item => (
//             <div key={item.id} className={styles.step}>
//               {item.video_url ? (
//                 <Link
//                   className={styles.thumb}
//                   external
//                   to={item.video_url}
//                   target="_blank"
//                 >
//                   <div
//                     className={styles.image}
//                     style={{ backgroundImage: `url(${item.thumbnail_image})` }}
//                   />
//                   <div className={styles.play}>
//                     <PlayIcon className={styles.icon} />
//                   </div>
//                 </Link>
//               ) : (
//                 <div className={styles.thumb}>
//                   <div className={styles.comingSoon}>
//                     <FormattedMessage defaultMessage="Coming Soon" />
//                   </div>
//                 </div>
//               )}

//               <div className={styles.title}>{item.title}</div>
//               <Link
//                 className={styles.link}
//                 external
//                 to={item.pdf}
//                 target="_blank"
//               >
//                 <FormattedMessage defaultMessage="Download instructions (PDF)" />
//               </Link>
//               {!!item.secondary_pdf_url && (
//                 <Link
//                   className={styles.link}
//                   external
//                   to={item.secondary_pdf_url}
//                   target="_blank"
//                 >
//                   {item.secondary_pdf_password ? (
//                     <FormattedMessage
//                       defaultMessage="Alternative Server (PW: {password})"
//                       values={{ password: item.secondary_pdf_password }}
//                     />
//                   ) : (
//                     <FormattedMessage defaultMessage="Alternative Server" />
//                   )}
//                 </Link>
//               )}
//             </div>
//           ))}
//         </div>
//       </ContentPageWrapper>
//     </Layout>
//   );
// };

// export default observer(InstructionsPage);

import React from 'react';
import Redirect from '../../components/Redirect';

const IndexPage = () => {
  return <Redirect to="https://www.stk-workshop.com/" includeQuery />;
  // return <Redirect to="/r2d2" includeQuery />;
};

export default IndexPage;
